import { Tooltip, TooltipProps, styled, tooltipClasses } from '@mui/material';

export const CustomWidthTooltip = styled(({ className, children, ...props }: TooltipProps) => (
  <Tooltip {...props} classes={{ popper: className }}>
    {children}
  </Tooltip>
))({
  [`& .${tooltipClasses.tooltip}`]: {
    minWidth: '30rem',
    maxWidth: '100%',
  },
});
